import React from "react";

import "./diff.scss";

import DiffDetail from "./DiffDetail";

const DiffData = () => {
  return <div className="bpl-container"><DiffDetail /></div>
};

export default DiffData;
